import axios from '../../../axiosInstance.ts'
import {Measure} from '@/features/measures/services/types.ts'
import {z} from 'zod'
import {MetaProps} from '@/types.ts'

export const HttpGetMeasuresResponse = z.object({
    data: Measure.partial().array(),
    meta: MetaProps
})

export const httpGetMeasures = ({
    page,
    search,
    filters,
    perPage,
    searchAfter
}: {
    page: number
    search: string
    filters: any
    perPage: number
    searchAfter?: (number | string)[] | null
}) => {
    return axios.get(`/v1/measures`, {
        params: {
            page,
            perPage: perPage,
            ...(search && {search}),
            ...(filters.activeTab !== 'all' && {type: filters.activeTab}),
            subTypes: filters.type_of_measure.map((v: {id: string}) => v.id),
            appealYears: filters.general_role.map((v: {id: string}) => v.id),
            sectionsIds: filters.section.map((v: {id: string}) => v.id),
            headquarterLocationIds: filters.site.map((v: {id: string}) => v.id),
            involvedPartiesIds: filters.counter_part.map((v: {id: string}) => v.id),
            judicialPanelMembersIds: filters.panel.map((v: {id: string}) => v.id),
            ...(filters.general_number?.length > 0 && {appealNumber: filters.general_number}),
            ...(filters.orderBy && {orderBy: filters.orderBy}),
            ...(filters.orderDirection && {orderDirection: filters.orderDirection}),
            ...(searchAfter !== null && searchAfter !== undefined && {searchAfter})
        }
    })
}

export const HttpGetFilterResponse = z.object({
    data: z
        .array(
            z.object({
                id: z.string(),
                name: z.string().optional(),
                keyName: z.string().optional(),
                keyTarName: z.string().optional()
            })
        )
        .optional(),
    meta: MetaProps
})

export const httpGetSections = ({page, search}: {page: number; search: string}) => {
    return axios.get(`/v1/sections`, {params: {perPage: 100, page, ...(search && {search})}})
}

export const httpGetHeadquarters = ({page, search}: {page: number; search: string}) => {
    return axios.get(`/v1/headquarter-locations`, {params: {perPage: 100, page, ...(search && {search})}})
}

export const httpGetJudicialPanel = ({page, search}: {page: number; search: string}) => {
    return axios.get(`/v1/judicial-panel/members`, {params: {perPage: 100, page, ...(search && {search})}})
}

export const httpGetInvolvedParties = ({page, search}: {page: number; search: string}) => {
    return axios.get(`/v1/involved-parties`, {params: {perPage: 100, page, ...(search && {search})}})
}

export const httpGetMeasuresTypes = () => {
    return axios.get(`/v1/measures/types`)
}

export const httpGetMeasureSubTypes = () => {
    return axios.get(`/v1/measures/subTypes`)
}

export const httpGetMeasureGeneralRole = () => {
    return axios.get(`/v1/measures/appeal-years`)
}

export const httpGetInvolvedPartyById = (id: string) => {
    return axios.get(`/v1/involved-parties/${id}`)
}

export const httpGetHeadquarterById = (id: string) => {
    return axios.get(`/v1/headquarter-locations/${id}`)
}

export const httpGetSectionById = (id: string) => {
    return axios.get(`/v1/sections/${id}`)
}

export const httpGetJudicialPanelMemberById = (id: string) => {
    return axios.get(`/v1/judicial-panel/members/${id}`)
}
